export class MaxMultStorageService {
    private  setCookie(name: string, value: string, days: number): void {
        const expires = new Date(Date.now() + days * 864e5).toUTCString();
        document.cookie = `${name}=${encodeURIComponent(value)}; expires=${expires}; path=/`;
    }

    private getCookie(name: string): string | null {
        const cookies = document.cookie.split('; ');
        for (const cookie of cookies) {
            const [cookieName, cookieValue] = cookie.split('=');
            if (cookieName === name) {
                return decodeURIComponent(cookieValue);
            }
        }
        return null;
    }

    public setMaxMult(projectId: string, maxMult: number): void {
        const cookieName = `maxMult_${projectId}`;
        this.setCookie(cookieName, maxMult.toString(), 8);
    }

    public getMaxMult(projectId: string): number | null {
        const cookieName = `maxMult_${projectId}`;
        const value = this.getCookie(cookieName);
        if (value === null) {
             return null;
        }
        
        const num = Number(value);
        return Number.isNaN(num) ? null : num;
    }
}